import { computed, makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreInstitution,
} from '../firestore/Institution/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class Institution extends ObservableModelWithDecorators<FirestoreInstitution> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreInstitution>
  ) {
    super(repository, doc)

    makeObservable(this)
  }

  @computed
  get hasLtiIssues() {
    return (
      this.isLoaded &&
      this.data.ltiPayloadIssues !== undefined &&
      Object.keys(this.data.ltiPayloadIssues).length > 0
    )
  }
}
